import { useUser } from "@/hooks/useUser";
import { User } from "@/types/User";

const useTimezone = () => {
  const { data: user } = useUser();
  const tz = (user?.data as User)?.time_zone;
  return tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export default useTimezone;
